import { ChargeTest, RangeTest } from '@appTypes/carModelType';
import { Season } from '@appTypes/ElPrixContextData';

export type TestData = RangeTest & Pick<ChargeTest, 'maxChargeEfficiency' | 'batteryCapacity'>;
export type TestGroup = Record<`${Season}_${string}`, { tests: Record<string, TestData> }>;

export const formatTestSeason = (season: Season, dateString: string) =>
  `${season === 'summer' ? 'Sommer' : 'Vinter'} ${new Date(dateString).getFullYear()}`;

export const groupRangeTests = (rangeTests: RangeTest[], chargeTests: ChargeTest[] = []): TestGroup =>
  rangeTests.reduce((groups, rangeTest) => {
    const { id, context } = rangeTest;
    const key = `${context.season}_${context.testDate}` as keyof TestGroup;
    const chargeTest = chargeTests.find((candidate) => candidate.id === id);
    const test = {
      ...rangeTest,
      maxChargeEfficiency: chargeTest?.maxChargeEfficiency,
      batteryCapacity: chargeTest?.batteryCapacity,
    };
    return {
      ...groups,
      [key]: { tests: { ...groups[key]?.tests, [id]: test } },
    };
  }, {} as TestGroup);
